(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('companyImages', CompanyImages)

    /** @ngInject */
    function CompanyImages($q, $rootScope, CompanyImageService, LoadingHelper, NotifyHelper, UtilHelper, sweetAlert, FlowConfigurationHelper, ImagePathHelper, PATHS) {
        function CompanyImagesDirectiveController($scope) {
            const vm = this;
            let galleryUploadedImages = [];

            // Watch on show tab
            let removeWatchShow = $scope.$watch('vm.show', (newValue, oldValue) => {
                if (newValue)
                    init();
            })

            $scope.$on('$destroy', () => {
                removeWatchShow();
            })

            // Main image
            vm.flowFileAdded = ($file, $flow, isGallery = false) => {
                let blacklist = ['png', 'gif', 'jpg', 'jpeg'];
                let extension = $file.getExtension();

                let form = '.image';

                if (isGallery) {
                    form = '.gallery';
                }

                if (!blacklist.includes(extension)) {
                    NotifyHelper.error('Apenas imagens nos formatos: PNG, JPG, JPEG ou GIF são permitidas.');
                    UtilHelper.setErrorMessageForm(form, 'Formato inválido.', true);
                    return false;
                }

                vm.oldFormImageMain = vm.companyMainImage.Url;

                if (isGallery)
                    angular.extend($flow.opts, vm.flowOptionsGallery);
                else {
                    angular.extend($flow.opts, vm.flowOptionsMain);
                    LoadingHelper.startLoading('.loading-holder');
                }

                UtilHelper.removeErrorMessageForm(form);
            }

            vm.flowFileFinishedMain = ($file, $message) => {
                let message = angular.fromJson($message);

                vm.companyMainImage.Url = message.FileSaveName;
                vm.companyMainImage.Display = ImagePathHelper.imageHandlerPath('company', vm.companyData.Id, message.FileSaveName);

                let imageData = {
                    CompanyId: vm.companyData.Id,
                    Main: true,
                    Url: vm.companyMainImage.Url,
                    Description: ''
                }

                vm.saveImage(imageData);
            }

            // Gallery
            vm.flowFileFinishedGallery = ($file, $message, $flow) => {
                let message = angular.fromJson($message);

                message.uniqueIdentifier = $file.uniqueIdentifier;

                galleryUploadedImages.push(message)

                if (galleryUploadedImages.length == $flow.files.length) {
                    $flow.files = [];

                    let uploadPromisses = [];

                    for (let index = 0; index < galleryUploadedImages.length; index++) {
                        const imageUpload = galleryUploadedImages[index];

                        let imageData = {
                            CompanyId: vm.companyData.Id,
                            Main: false,
                            Url: imageUpload.FileSaveName,
                            Description: ''
                        }

                        uploadPromisses.push(vm.saveImage(imageData, imageUpload.uniqueIdentifier, false));
                    }

                    galleryUploadedImages = [];

                    LoadingHelper.startLoading('.loading-holder');

                    $q.all(uploadPromisses)
                        .then(() => {
                            UtilHelper.successCallback();
                            LoadingHelper.stopLoading('.loading-holder');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            }

            // On file submitted
            vm.flowFileSubmitted = $flow => {
                $flow.upload();
            }

            // On error in upload
            vm.flowFileError = $flow => {
                $flow.files = [];

                NotifyHelper.error('Não foi possível salvar a imagem.');
                LoadingHelper.stopLoading('.loading-holder');
            }

            // CRUD
            vm.saveImage = (imageData, fileIdentifier, showLoading = true) => {
                if (showLoading)
                    LoadingHelper.startLoading('.loading-holder');

                return CompanyImageService
                    .post(imageData)
                    .then(success => {
                        if (!imageData.Main) {
                            success.fullPath = ImagePathHelper.imageHandlerPath('company', vm.companyData.Id, imageData.Url);

                            vm.companyGallery.push(success);

                            $('#' + fileIdentifier).remove();
                        } else
                            vm.companyMainImage = success;

                        if (showLoading) {
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('image');
                        }
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    })
            }

            vm.updateImage = imageData => {
                LoadingHelper.startLoading('.loading-holder');

                CompanyImageService
                    .put(imageData)
                    .then(() => {
                        LoadingHelper.stopLoading('.loading-holder');
                        UtilHelper.successCallback();
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    })
            }

            vm.deleteImage = (imageData, isMainImage = false) => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Não é possível desfazer essa ação!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        LoadingHelper.startLoading('.loading-holder');

                        if (isMainImage)
                            imageData = vm.companyMainImage;

                        CompanyImageService
                            .deleteImage(imageData.Id)
                            .then(() => {
                                if (!imageData.Main) {
                                    var index = vm.companyGallery.indexOf(imageData);

                                    if (index !== -1)
                                        vm.companyGallery.splice(index, 1);
                                } else {
                                    vm.companyMainImage = {
                                        Url: '',
                                        Display: ''
                                    }

                                    if (vm.flowScopeMain.flow.files.length)
                                        vm.flowScopeMain.flow.files[0].cancel();
                                }

                                LoadingHelper.stopLoading('.loading-holder');
                                UtilHelper.successCallback();
                            }, error => {
                                UtilHelper.errorCallback(error);
                                LoadingHelper.stopLoading('.loading-holder');
                            })
                    }
                })
            }

            function getImages() {
                if (vm.companyData != null && vm.companyData.CompanyImages.length) {
                    let companyMainImage = vm.companyData.CompanyImages.find(image => (image.Main));

                    if (companyMainImage) {
                        vm.companyMainImage = companyMainImage;
                        vm.companyMainImage.Display = ImagePathHelper.imageHandlerPath('company', vm.companyData.Id, companyMainImage.Url);
                    }

                    vm.companyGallery = vm.companyData.CompanyImages
                        .filter(image => (!image.Main))
                        .reduce((acc, cur) => {
                            cur.fullPath = ImagePathHelper.imageHandlerPath('company', vm.companyData.Id, cur.Url);

                            acc.push(cur);

                            return acc;
                        }, []);
                }

                LoadingHelper.stopLoading('.loading-holder');
            }

            function initVars() {
                vm.canUserEdit = $rootScope.canUserEdit;

                vm.companyMainImage = {
                    Url: '',
                    Display: ''
                }
                vm.companyGallery = [];

                vm.flowOptionsMain = {
                    query: () => {
                        return {
                            Path: `company/${vm.companyData.Id}`,
                            OldImage: vm.oldFormImageMain,
                            CreateThumb: false,
                            CreateThumbAdmin: false
                        }
                    }
                }

                vm.flowOptionsGallery = {
                    query: () => {
                        return {
                            Path: `company/${vm.companyData.Id}`,
                            CreateThumb: false,
                            CreateThumbAdmin: false,
                            MaxSize: 2000000
                        }
                    }
                }

                angular.extend(vm.flowOptionsMain, FlowConfigurationHelper.getFlowOptionsDefaults());
                angular.extend(vm.flowOptionsGallery, FlowConfigurationHelper.getFlowOptionsDefaultsGallery());
            }

            function init() {
                LoadingHelper.startLoading('.loading-holder');

                initVars();
                getImages();
            }
        }

        return {
            bindToController: true,
            controller: CompanyImagesDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/company-images/company-images.html`,
            scope: {
                companyData: '=',
                show: '='
            }
        }
    }
}());